export default __webpack_public_path__ + "static/aquipagoLogo-e41bfc3ca2fe9c0eb7e9fe08f5b91e76.png";